module.exports = __webpack_public_path__ + "static/img/login.9b43436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login.png
// module id = P6QF
// module chunks = 1